
import {
  h,
  onActivated,
  onDeactivated,
  onBeforeMount,
  onBeforeUnmount,
  defineComponent,
} from 'vue';

export default defineComponent({
  name: 'oxd-tab-panel',
  props: {
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['activate', 'deactivate'],
  setup(props, context) {
    onActivated(() => context.emit('activate'));
    onBeforeMount(() => context.emit('activate'));
    onDeactivated(() => context.emit('deactivate'));
    onBeforeUnmount(() => context.emit('deactivate'));

    return () =>
      h(
        'div',
        {
          id: props.name,
          class: 'oxd-tab-panel',
        },
        context.slots.default?.(),
      );
  },
});
